"use strict";

import React, {Component, PropTypes} from "react";
import BGAssetLess from "./BGAsset.less";

export default class BGAsset extends Component {
    static propTypes = {
        name: PropTypes.string.isRequired,
        alt: PropTypes.string
    };

    render() {
        return <span title={this.props.alt} className={BGAssetLess[this.props.name]}/>
    }

}


/** WEBPACK FOOTER **
 ** ./src/templates/BGAsset.jsx
 **/